import React, { useState, useEffect } from 'react';
import { Avatar, Box } from '@mui/material';
import { getExchangeIcon, getCryptoIcon, getFallbackCryptoIcon } from '../services/iconService';

/**
 * Exchange Icon Component
 */
export const ExchangeIcon = ({ exchangeName, size = 24, sx = {} }) => {
  const iconUrl = getExchangeIcon(exchangeName);

  return (
    <Avatar
      src={iconUrl}
      alt={exchangeName}
      sx={{
        width: size,
        height: size,
        ...sx
      }}
    >
      {exchangeName?.charAt(0)?.toUpperCase()}
    </Avatar>
  );
};

/**
 * Cryptocurrency Icon Component
 */
export const CryptoIcon = ({ symbol, size = 24, sx = {} }) => {
  const [iconUrl, setIconUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (symbol) {
      setLoading(true);
      getCryptoIcon(symbol)
        .then(url => {
          setIconUrl(url || getFallbackCryptoIcon());
          setLoading(false);
        })
        .catch(err => {
          console.warn('Failed to load crypto icon:', err);
          setIconUrl(getFallbackCryptoIcon());
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [symbol]);

  if (loading) {
    return (
      <Avatar
        sx={{
          width: size,
          height: size,
          bgcolor: 'grey.300',
          ...sx
        }}
      >
        {symbol?.charAt(0)?.toUpperCase()}
      </Avatar>
    );
  }

  return (
    <Avatar
      src={iconUrl}
      alt={symbol}
      sx={{
        width: size,
        height: size,
        ...sx
      }}
    >
      {symbol?.charAt(0)?.toUpperCase()}
    </Avatar>
  );
};

/**
 * Combined Exchange and Symbol Icon Component
 */
export const ExchangeSymbolIcon = ({ 
  exchangeName, 
  symbol, 
  showBoth = true, 
  size = 24, 
  spacing = 1,
  sx = {} 
}) => {
  if (showBoth) {
    return (
      <Box display="flex" alignItems="center" gap={spacing} sx={sx}>
        <ExchangeIcon exchangeName={exchangeName} size={size} />
        <CryptoIcon symbol={symbol} size={size} />
      </Box>
    );
  }
  
  // Show only symbol icon if showBoth is false
  return <CryptoIcon symbol={symbol} size={size} sx={sx} />;
};